import {SkeletonCard} from '../skeleton-card';
import {StyledResultsSectionContainer, StyledResultWrapper} from './styled';
import React from 'react';

const SkeletonSearchResultsSection: React.FC = () => {
  return (
    <StyledResultsSectionContainer
      className="results-section_main-container"
      data-testid="skeleton-loader"
      
    >
      {Array.from({length: 6}).map((_, index) => (
        <StyledResultWrapper className="results-section_card-item" key={index}>
          <SkeletonCard />
        </StyledResultWrapper>
      ))}
    </StyledResultsSectionContainer>
  );
};

export default SkeletonSearchResultsSection;
